import { SystemMessage } from 'components/Dialogue';
import LazyOrderMessage from '../LazyOrderMessage';
import { BaseSysMsgProps } from './types';
import { memo } from 'react';

export const SysUserEnterFromOrderMsg = memo((props: BaseSysMsgProps) => {
  const { raw, conversation } = props;
  const { sysUserEnterFromOrderContent } = raw;

  if (!sysUserEnterFromOrderContent || !conversation) {
    return null;
  }

  const { externalStoreId, externalOrderSn } = sysUserEnterFromOrderContent;
  const { buyerId, storeId, tunnelAccountId, channel } = conversation;

  return (
    <SystemMessage>
      <LazyOrderMessage
        isUserEnter
        rawMsg={raw}
        buyerId={buyerId}
        storeId={storeId}
        tunnelAccountId={tunnelAccountId}
        externalTradeId={externalOrderSn}
        externalStoreId={externalStoreId}
        channel={channel}
      />
    </SystemMessage>
  );
});
